module.exports = __webpack_public_path__ + "img/15.38ddd8eb.png";